import React, { useEffect, useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import RangeSlider from 'react-bootstrap-range-slider'

export default function Buffs({globalDamage, setGlobalDamage, archtype, secondary, defOG, setDefOG, corrOG, setCorrOG, defFort, setDefFort, corrFort, setCorrFort, defPB, setDefPB, corrPB, setCorrPB, defWoP, setDefWoP, corrWoP, setCorrWoP, defEmpCircuit, setDefEmpCircuit, corrEmpCircuit, setCorrEmpCircuit, setToxins}) {
  const [buildUpValue, setBuildUpValue] = useState(0)
  const [buildUp, setBuildUp] = useState(false)
  const [aimValue, setAimValue] = useState(0)
  const [aim, setAim] = useState(false)
  const [gaussiansValue, setGaussiansValue] = useState(0)
  const [gaussians, setGaussians] = useState(false)

  useEffect(() => {
    if (secondary === "SonicManip") {setBuildUpValue(75)}
    if (secondary === "Temporal" || secondary === "TactArrow") {setBuildUpValue(81.25)}
    if (secondary === "other") {setBuildUpValue(100)}
  }, [secondary])
  useEffect(() => {
    if (archtype === "Blaster") {setAimValue(62.5); setGaussiansValue(100)}
    if (archtype === 'corruptor') {setAimValue(42.5); setGaussiansValue(68)}
    if (archtype === 'defender') {setAimValue(50); setGaussiansValue(80)}
    if (archtype === 'dom') {setGaussiansValue(68)}
    if (archtype === 'controller') {setGaussiansValue(64)}
  }, [archtype])
  useEffect(() => {
    const totalBoost = (defOG*82.5)+(corrOG*66)+(defFort*31.25)+(corrFort*25)+(defPB*62.5)+(corrPB*50)+(defWoP*20)+(corrWoP*16)+(defEmpCircuit*37.5)+(corrEmpCircuit*30)+(buildUp && buildUpValue)+(aim && aimValue)+(gaussians && gaussiansValue)
    setGlobalDamage(totalBoost)
  }, [setGlobalDamage, defOG, corrOG, defFort, corrFort, defPB, corrPB, defWoP, corrWoP, defEmpCircuit, corrEmpCircuit, buildUp, buildUpValue, aim, aimValue, gaussians, gaussiansValue])
  return (
    <Row className='mt-2'>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Defender - Overgrowth</Form.Label>
          <RangeSlider
              value={defOG}
              min={0}
              max={6}
              size="lg"
              onChange={e => setDefOG(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Corr - Overgrowth</Form.Label>
          <RangeSlider
              value={corrOG}
              min={0}
              max={6}
              size="lg"
              onChange={e => setCorrOG(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Def - Fort</Form.Label>
          <RangeSlider
              value={defFort}
              min={0}
              max={2}
              size="lg"
              onChange={e => setDefFort(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Cont - Fort</Form.Label>
          <RangeSlider
              value={corrFort}
              min={0}
              max={2}
              size="lg"
              onChange={e => setCorrFort(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Def - Painbringer</Form.Label>
          <RangeSlider
              value={defPB}
              min={0}
              max={2}
              size="lg"
              onChange={e => setDefPB(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Corr - Painbringer</Form.Label>
          <RangeSlider
              value={corrPB}
              min={0}
              max={2}
              size="lg"
              onChange={e => setCorrPB(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Def - World of Pain</Form.Label>
          <RangeSlider
              value={defWoP}
              min={0}
              max={2}
              size="lg"
              onChange={e => setDefWoP(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Corr - World of Pain</Form.Label>
          <RangeSlider
              value={corrWoP}
              min={0}
              max={2}
              size="lg"
              onChange={e => setCorrWoP(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Def - Empowering Circuit</Form.Label>
          <RangeSlider
              value={defEmpCircuit}
              min={0}
              max={2}
              size="lg"
              onChange={e => setDefEmpCircuit(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Corr - Empowering Circuit</Form.Label>
          <RangeSlider
              value={corrEmpCircuit}
              min={0}
              max={2}
              size="lg"
              onChange={e => setCorrEmpCircuit(e.target.value)}
            />
        </Form.Group>
      </Col>
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Aim</Form.Label>
          <Form.Check  className="d-flex justify-content-center text-center" type="checkbox" onChange={(e) => e.target.checked ? setAim(true) : setAim(false)} />
        </Form.Group>
      </Col>
      {archtype === "Blaster" && secondary !== "Plant" && secondary !== "Ninja" ? <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Build Up</Form.Label>
          <Form.Check  className="d-flex justify-content-center text-center" type="checkbox" onChange={(e) => e.target.checked ? setBuildUp(true) : setBuildUp(false)} />
        </Form.Group>
      </Col> : null}
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Gaussian's Build Up</Form.Label>
          <Form.Check  className="d-flex justify-content-center text-center" type="checkbox" onChange={(e) => e.target.checked ? setGaussians(true) : setGaussians(false)} />
        </Form.Group>
      </Col>
      {secondary === "Plant" ? <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Toxins</Form.Label>
          <Form.Check  className="d-flex justify-content-center text-center" type="checkbox" onChange={(e) => e.target.checked ? setToxins(true) : setToxins(false)} />
        </Form.Group>
      </Col> : null}
      <Col xs={6} md={3} className='p-2'>
        <Form.Group className='mb-3 bg-secondary border p-2 rounded resists' controlId='formBasicCheckbox'>
          <Form.Label className='d-flex justify-content-center text-center'>Global Damage:</Form.Label>
          <Form.Label className='d-flex justify-content-center text-center'>{globalDamage}</Form.Label>
          {/* <Form.Check  className="d-flex justify-content-center text-center" type="checkbox" onChange={(e) => e.target.checked ? setGaussians(false) : setGaussians(true)} /> */}
        </Form.Group>
      </Col>
    </Row>
  )
}
